<template>
  <div class="system-topology">
    <!-- 5个设备图像 -->
    <!-- 左上角：光伏 (PV) -->
    <div class="device-img pv-device" :style="{ opacity: hasPvModule ? 1 : 0.2 }">
      <img :src="require('@/assets/images/station-monitor/image_13.png')" class="device-base" />
      <img :src="require('@/assets/images/station-monitor/image_14.png')" class="device-overlay" />
    </div>

    <!-- 左下角：充电桩 (Charger) -->
    <div class="device-img charger-device" :style="{ opacity: hasChargerModule ? 1 : 0.2 }">
      <img :src="require('@/assets/images/station-monitor/image_15.png')" class="device-base" />
      <img :src="require('@/assets/images/station-monitor/image_16.png')" class="device-overlay" />
    </div>

    <!-- 中间：储能系统 (Storage) -->
    <div class="device-img storage-device">
      <img :src="require('@/assets/images/station-monitor/image_17.png')" class="device-base" />
      <img :src="require('@/assets/images/station-monitor/image_18.png')" class="device-overlay" />
    </div>

    <!-- 右上角：电网 (Grid) -->
    <div class="device-img grid-device">
      <img :src="require('@/assets/images/station-monitor/image_19.png')" class="device-base" />
      <img :src="require('@/assets/images/station-monitor/image_20.png')" class="device-overlay" />
    </div>

    <!-- 右下角：负载 (Load) -->
    <div class="device-img load-device">
      <img :src="require('@/assets/images/station-monitor/image_21.png')" class="device-base" />
      <img :src="require('@/assets/images/station-monitor/image_22.png')" class="device-overlay" />
    </div>

    <!-- 连接线和箭头 -->
    <div class="connection-lines">
      <!-- 上方连接线组 -->
      <div class="lines-top">
        <img :src="require('@/assets/images/station-monitor/image_23.png')" class="line-arrow line-23"
          :style="{ opacity: hasPvModule ? 1 : 0.2 }" />
        <div class="line-group line-group-1">
          <div class="line-box line-box-24" :style="{ opacity: hasPvModule ? 1 : 0.2 }">
            <img :src="require('@/assets/images/station-monitor/image_25.png')" class="arrow-icon" />
          </div>
          <img :src="require('@/assets/images/station-monitor/image_26.png')" class="line-arrow line-26" />
        </div>
        <div class="line-group line-group-2">
          <div class="line-box line-box-27">
            <img :src="require('@/assets/images/station-monitor/image_28.png')" class="arrow-icon" />
          </div>
          <img :src="require('@/assets/images/station-monitor/image_29.png')" class="line-arrow line-29" />
        </div>
        <img :src="require('@/assets/images/station-monitor/image_30.png')" class="line-arrow line-30" />
      </div>

      <!-- 下方连接线组 -->
      <div class="lines-bottom">
        <div class="line-group line-group-3" :style="{ opacity: hasChargerModule ? 1 : 0.2 }">
          <div class="line-box line-box-31">
            <img :src="require('@/assets/images/station-monitor/image_32.png')" class="arrow-icon" />
          </div>
          <img :src="require('@/assets/images/station-monitor/image_33.png')" class="line-arrow line-33" />
        </div>
        <img :src="require('@/assets/images/station-monitor/image_34.png')" class="line-arrow line-34" />
        <img :src="require('@/assets/images/station-monitor/image_35.png')" class="line-arrow line-35" />
        <div class="line-group line-group-4">
          <div class="line-box line-box-36">
            <img :src="require('@/assets/images/station-monitor/image_37.png')" class="arrow-icon" />
          </div>
          <img :src="require('@/assets/images/station-monitor/image_38.png')" class="line-arrow line-38" />
        </div>
      </div>
    </div>

    <!-- 设备标签和数据框 -->
    <div class="device-labels">
      <!-- 光伏标签 (左上) -->
      <div class="device-label label-pv" :style="{ opacity: hasPvModule ? 1 : 0.2 }">
        <div class="label-box">
          <div class="label-text">光伏</div>
          <img :src="require('@/assets/images/station-monitor/image_39.png')" class="label-icon" />
        </div>
      </div>

      <!-- 光伏数据框 - 在光伏到储能连接线箭头上方 -->
      <div class="diagram-data-box diagram-data-box-pv" v-show="hasPvModule && Object.keys(pvData).length > 0">
        <!-- <div class="diagram-data-row" v-for="(value, key) in pvData" :key="key">
          <span class="diagram-data-label">{{ key }}：</span>
          <span class="diagram-data-value">{{ value ?? '--' }}</span>
        </div> -->
        <div class="diagram-data-row">
          <span class="diagram-data-label">p：</span>
          <span class="diagram-data-value">{{ pvData.p }}kW</span>
        </div>
      </div>

      <!-- 电网数据框 - 在电网到储能连接线箭头上方 -->
      <div class="diagram-data-box diagram-data-box-grid" v-show="Object.keys(gridData).length > 0">
        <!-- <div class="diagram-data-row" v-for="(value, key) in gridData" :key="key">
          <span class="diagram-data-label">{{ key }}：</span>
          <span class="diagram-data-value">{{ value ?? '--' }}</span>
        </div> -->
        <div class="diagram-data-row">
          <span class="diagram-data-label" v-tooltip="'u_ab'">电压: </span>
          <span class="diagram-data-value">{{ gridData.u_ab }}V</span>
        </div>
        <div class="diagram-data-row">
          <span class="diagram-data-label" v-tooltip="'i_a'">电流: </span>
          <span class="diagram-data-value">{{ gridData.i_a }}A</span>
        </div>
        <div class="diagram-data-row">
          <span class="diagram-data-label" v-tooltip="'p'">功率: </span>
          <span class="diagram-data-value">{{ gridData.p }}kW</span>
        </div>
      </div>

      <!-- 电网标签 (右上) -->
      <div class="device-label label-grid">
        <div class="label-box">
          <div class="label-text">电网</div>
          <!-- <img :src="require('@/assets/images/station-monitor/image_42.png')" class="label-icon" /> -->
        </div>
      </div>

      <!-- 储能系统标签 (中间) -->
      <div class="device-label label-storage">
        <div class="label-box label-box-wide" @click="openDetailDialog">
          <div class="label-text">储能系统</div>
          <img :src="require('@/assets/images/station-monitor/image_42.png')" class="label-icon" />
        </div>
      </div>

      <!-- 储能系统数据框 - 在储能系统旁边 -->
      <div class="diagram-data-box diagram-data-box-storage" v-show="Object.keys(essData).length > 0">
        <div class="diagram-data-row" v-for="(value, key) in essData" :key="key">
          <span class="diagram-data-label">{{ key }}：</span>
          <span class="diagram-data-value">{{ value ?? '--' }}</span>
        </div>
      </div>

      <!-- 充电桩数据框 - 在充电桩到储能连接线箭头上方 -->
      <div class="diagram-data-box diagram-data-box-charger"
        v-show="hasChargerModule && Object.keys(chargerData).length > 0">
        <!-- <div class="diagram-data-row" v-for="(value, key) in chargerData" :key="key">
          <span class="diagram-data-label">{{ key }}：</span>
          <span class="diagram-data-value">{{ value ?? '--' }}</span>
        </div> -->
        <div class="diagram-data-row">
          <span class="diagram-data-label">p：</span>
          <span class="diagram-data-value">{{ chargerData.p }}kW</span>
        </div>
      </div>

      <!-- 负载数据框 - 在储能到负载连接线箭头上方 -->
      <div class="diagram-data-box diagram-data-box-load" v-show="Object.keys(loadData).length > 0">
        <!-- <div class="diagram-data-row" v-for="(value, key) in loadData" :key="key">
          <span class="diagram-data-label">{{ key }}：</span>
          <span class="diagram-data-value">{{ value ?? '--' }}</span>
        </div> -->
        <div class="diagram-data-row">
          <span class="diagram-data-label" v-tooltip="'u_ab'">电压: </span>
          <span class="diagram-data-value">{{ loadData.u_ab }}V</span>
        </div>
        <div class="diagram-data-row">
          <span class="diagram-data-label" v-tooltip="'i_a'">电流: </span>
          <span class="diagram-data-value">{{ loadData.i_a }}A</span>
        </div>
        <div class="diagram-data-row">
          <span class="diagram-data-label" v-tooltip="'p'">功率: </span>
          <span class="diagram-data-value">{{ loadData.p }}kW</span>
        </div>
      </div>

      <!-- 充电桩标签 (左下) -->
      <div class="device-label label-charger" :style="{ opacity: hasChargerModule ? 1 : 0.2 }">
        <div class="label-box label-box-charger">
          <div class="label-text">充电桩</div>
          <img :src="require('@/assets/images/station-monitor/image_42.png')" class="label-icon" />
        </div>
      </div>

      <!-- 负载标签 (右下) -->
      <div class="device-label label-load">
        <div class="label-box">
          <div class="label-text">负载</div>
          <!-- <img :src="require('@/assets/images/station-monitor/image_42.png')" class="label-icon" /> -->
        </div>
      </div>
    </div>
  </div>

  <!-- 储能系统详情弹框 -->
  <EnergyStorageDetailDialog v-model="showDetailDialog" />
</template>

<script setup>
import { ref, computed } from 'vue'
import EnergyStorageDetailDialog from './real-time-monitor/EnergyStorageDetailDialog.vue'

const props = defineProps({
  hasPvModule: {
    type: Boolean,
    default: true,
  },
  hasChargerModule: {
    type: Boolean,
    default: true,
  },
  diagramData: {
    type: Object,
    default: () => ({})
  }
})

// 详情弹框
const showDetailDialog = ref(false)

// 打开详情弹框
const openDetailDialog = () => {
  showDetailDialog.value = true
}

// 计算光伏数据 - 直接返回接口所有字段
const pvData = computed(() => {
  return props.diagramData?.riagram?.pv || {}
})

// 计算电网数据 - 直接返回接口所有字段
const gridData = computed(() => {
  return props.diagramData?.riagram?.grid || {}
})

// 计算储能系统数据 - 直接返回接口所有字段
const essData = computed(() => {
  return props.diagramData?.riagram?.ess || {}
})

// 计算充电桩数据 - 直接返回接口所有字段
const chargerData = computed(() => {
  return props.diagramData?.riagram?.cp || {}
})

// 计算负载数据 - 直接返回接口所有字段
const loadData = computed(() => {
  return props.diagramData?.riagram?.load || {}
})
</script>

<style scoped lang="scss">
.system-topology {
  position: relative;
  width: 100%;
  height: 100%;
}

// 设备图像
.device-img {
  position: absolute;

  .device-base {
    position: absolute;
  }

  .device-overlay {
    position: absolute;
  }
}

// 光伏设备 (左上)
.pv-device {
  top: 118px;
  left: 77.36px;
  width: 254.29px;
  height: 164.06px;

  .device-base {
    top: 40.94px;
    left: 0;
    width: 254.29px;
    height: 123.11px;
  }

  .device-overlay {
    top: 0;
    left: 57.64px;
    width: 140px;
    height: 131px;
  }
}

// 充电桩设备 (左下)
.charger-device {
  top: 354px;
  left: 76.84px;
  width: 255.31px;
  height: 163.55px;

  .device-base {
    top: 40.95px;
    left: 0;
    width: 255.31px;
    height: 122.61px;
  }

  .device-overlay {
    top: 0;
    left: 58.66px;
    width: 140px;
    height: 131px;
  }
}

// 储能系统设备 (中间)
.storage-device {
  top: 232px;
  left: 321.85px;
  width: 254.29px;
  height: 168.06px;

  .device-base {
    top: 16.50px;
    left: 0;
    width: 254.29px;
    height: 151.56px;
  }

  .device-overlay {
    top: 0;
    left: 57.15px;
    width: 140px;
    height: 134px;
  }
}

// 电网设备 (右上)
.grid-device {
  top: 73px;
  left: 565.84px;
  width: 255.31px;
  height: 208.55px;

  .device-base {
    top: 85.95px;
    left: 0;
    width: 255.31px;
    height: 122.61px;
  }

  .device-overlay {
    top: 0;
    left: 59.16px;
    width: 140px;
    height: 176px;
  }
}

// 负载设备 (右下)
.load-device {
  top: 336px;
  left: 564.84px;
  width: 255.31px;
  height: 181.56px;

  .device-base {
    top: 58.95px;
    left: 0;
    width: 255.31px;
    height: 122.61px;
  }

  .device-overlay {
    top: 0;
    left: 58.16px;
    width: 140px;
    height: 149px;
  }
}

// 连接线和箭头
.connection-lines {
  position: absolute;
  top: 247px;
  left: 261px;
  width: 372.50px;
  height: 182.50px;
}

.lines-top {
  width: 372.50px;
  height: 64.75px;
  display: flex;
  align-items: flex-start;
}

.line-23 {
  width: 11px;
  height: 6.75px;
  margin-top: 2px;
}

.line-group {
  position: relative;
}

.line-group-1 {
  width: 116px;
  height: 57.25px;
  margin-top: 7.50px;
}

.line-box {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;

  // 使用CSS绘制对角线
  &::before {
    content: '';
    position: absolute;
    z-index: 0;
    background-color: #3A68FF;
    height: 1px;
    transform-origin: left center;
  }

  .arrow-icon {
    position: relative;
    z-index: 1;
  }
}

.line-box-24 {
  width: 112.50px;
  height: 55px;

  // 对角线：从左上到右下
  &::before {
    top: 0;
    left: 0;
    width: 125px;
    transform: rotate(26deg);
  }

  .arrow-icon {
    width: 14px;
    height: 10px;
    margin-top: 21.50px;
    margin-left: 46px;
  }
}

.line-26 {
  position: absolute;
  top: 52.50px;
  left: 108px;
  width: 8px;
  height: 4.75px;
}

.line-group-2 {
  width: 117px;
  height: 57.75px;
  margin-top: 5.50px;
  margin-left: 119.50px;
}

.line-box-27 {
  width: 114px;
  height: 55.50px;
  margin-left: 3px;
  justify-content: flex-end;

  // 对角线：从右上到左下
  &::before {
    top: 0;
    right: 0;
    width: 125px;
    transform: rotate(-26deg);
    transform-origin: right center;
  }

  .arrow-icon {
    width: 14px;
    height: 10px;
    margin-top: 20.50px;
    margin-right: 46.50px;
  }
}

.line-29 {
  position: absolute;
  top: 52.50px;
  left: 0;
  width: 8.50px;
  height: 5.25px;
}

.line-30 {
  width: 10.67px;
  height: 6.50px;
}

.lines-bottom {
  width: 369.50px;
  height: 65px;
  margin-top: 52.75px;
  margin-left: 1px;
  display: flex;
  align-items: flex-start;
}

.line-group-3 {
  width: 116.50px;
  height: 57.50px;
  margin-top: 6px;
}

.line-box-31 {
  width: 113px;
  height: 55.50px;
  margin-left: 3.50px;
  justify-content: flex-end;
  overflow: visible;

  // 正对角线：从右上到左下
  &::before {
    top: 0;
    right: 0;
    width: 126px;
    transform: rotate(-26deg);
    transform-origin: right top;
  }

  .arrow-icon {
    width: 14px;
    height: 10px;
    margin-top: 22.50px;
    margin-right: 49.50px;
  }
}

.line-33 {
  position: absolute;
  top: 52px;
  left: 0;
  width: 9px;
  height: 5.50px;
}

.line-34 {
  width: 11px;
  height: 7px;
}

.line-35 {
  width: 11px;
  height: 6.75px;
  margin-top: 2px;
  margin-left: 117px;
}

.line-group-4 {
  width: 116px;
  height: 57.50px;
  margin-top: 7.50px;
}

.line-box-36 {
  width: 112px;
  height: 55px;

  // 正对角线：从左上到右下
  &::before {
    top: 0;
    left: 0;
    width: 125px;
    transform: rotate(26.1deg);
    transform-origin: left top;
  }

  .arrow-icon {
    width: 14px;
    height: 10px;
    margin-top: 20.50px;
    margin-left: 44px;
  }
}

.line-38 {
  position: absolute;
  top: 52.25px;
  left: 107px;
  width: 9px;
  height: 5.25px;
}

// 设备标签和数据框
.device-labels {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.device-label {
  position: absolute;
  pointer-events: auto;
}

.label-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 7px 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 1) 100%);
  border-radius: 10px;
  border: 0.5px solid rgba(255, 255, 255, 1);
  backdrop-filter: blur(7px);
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

.label-box-wide {
  padding: 7px 16px;
}

.label-box-charger {
  width: 109px;
  justify-content: flex-start;
  padding-left: 32px;
}

.label-text {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(46, 46, 46, 1);
  font-weight: 500;
  line-height: normal;
}

.label-icon {
  width: 10px;
  height: 10px;
}

// 数据框 - 使用CSS边框绘制，底部带向下的空心箭头
.diagram-data-box {
  position: absolute;
  border: 1px solid #FF8A67;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  pointer-events: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 68px;
  min-height: 30px;

  // 底部中间向下的空心三角箭头 - 使用两条边框线形成空心效果
  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 6px;
    height: 6px;
    background: rgba(255, 255, 255, 0.95);
    border-right: 1px solid #FF8A67;
    border-bottom: 1px solid #FF8A67;
    border-left: none;
    border-top: none;
  }
}

.diagram-data-row {
  display: flex;
  align-items: center;
  margin-top: 1px;
  min-width: 72px;

  &:first-child {
    margin-top: 0;
  }
}

.diagram-data-label {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 10px;
  color: rgba(255, 138, 103, 1);
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
}

.diagram-data-value {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 10px;
  color: rgba(255, 138, 103, 1);
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
}

// 光伏数据框 - 在光伏到储能连接线箭头正上方
.diagram-data-box-pv {
  top: 237px;
  left: 282px;
}

// 电网数据框 - 在电网到储能连接线箭头正上方
.diagram-data-box-grid {
  top: 215px;
  left: 522px;
}

// 储能系统数据框 - 在储能系统到负载连接线箭头正上方
.diagram-data-box-storage {
  top: 334px;
  left: 528px;
}

// 充电桩数据框 - 在充电桩到储能连接线箭头正上方
.diagram-data-box-charger {
  top: 354px;
  left: 280px;
}

// 负载数据框 - 在储能到负载连接线箭头正上方（与storage位置相同，可根据实际情况调整）
.diagram-data-box-load {
  top: 336px;
  left: 526px;
}

// 设备标签位置 - 根据HTML精确定位
.label-pv {
  top: 211px;
  left: 78px;
}

.label-grid {
  top: 209px;
  left: 734px;
}

.label-storage {
  top: 373px;
  left: 396px;
}

.label-charger {
  top: 472px;
  left: 78px;
}

.label-load {
  top: 472px;
  left: 734px;
}
</style>
